import React, {useState} from 'react'
import Switch from '@mui/material/Switch'
import {Header} from '../../components/Header'
import {LogoutPopup} from '../../components/NewComponents/LogoutPopup'
import settingUser from '../../assets/img/setting-user.svg'
import settingCircle2 from '../../assets/img/setting-circle-2.svg'
import settingCircle1 from '../../assets/img/setting-circle-1.svg'

import '../../assets/css/setting.css'
import {PasswordChange} from '../../components/NewComponents/settings/PasswordChange'
import {SwitchCustom} from '../../components/NewComponents/settings/SwitchCustom'

export const Settings = () => {
	const [LogoutState, setLogoutState] = useState(false)
	const [option, setoption] = useState(false)
	const [passwordChangePop, setpasswordChangePop] = useState(false)
	const [emailSettings, setemailSettings] = useState('pedroperez@123.cl')

	return (
		<div className='HomeNew settings'>
			{passwordChangePop && (
				<PasswordChange setpasswordChangePop={setpasswordChangePop} />
			)}

			<img src={settingCircle1} className='circle-1-setting' alt='' />
			<img src={settingCircle2} className='circle-2-setting' alt='' />
			{LogoutState && <LogoutPopup setLogoutState={setLogoutState} />}

			<Header setLogoutState={setLogoutState} />

			<div className='inner-header-setting'>
				<div>
					<img src={settingUser} alt='' />
					<p>Configuración de Perfil</p>
				</div>
			</div>

			<div className='step1'>
				<div className='profile-area'>
					<div className='profile-pic'>
						<img
							src='https://images.unsplash.com/photo-1599566150163-29194dcaad36?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8YXZhdGFyfGVufDB8fDB8fHww&auto=format&fit=crop&w=800&q=60'
							alt=''
						/>

						<div
							className='confirm-area'
							onClick={(e) => {
								setoption(true)
							}}
						>
							<svg
								width='21'
								height='14'
								viewBox='0 0 21 14'
								fill='none'
								xmlns='http://www.w3.org/2000/svg'
							>
								<path
									d='M17.175 8.35C17.075 8.35 16.9916 8.31667 16.925 8.25C16.8583 8.18333 16.825 8.1 16.825 8V5.35H14.175C14.075 5.35 13.9916 5.31667 13.925 5.25C13.8583 5.18333 13.825 5.1 13.825 5C13.825 4.9 13.8583 4.81667 13.925 4.75C13.9916 4.68333 14.075 4.65 14.175 4.65H16.825V2C16.825 1.9 16.8583 1.81667 16.925 1.75C16.9916 1.68333 17.075 1.65 17.175 1.65C17.275 1.65 17.3583 1.68333 17.425 1.75C17.4916 1.81667 17.525 1.9 17.525 2V4.65H20.175C20.275 4.65 20.3583 4.68333 20.425 4.75C20.4916 4.81667 20.525 4.9 20.525 5C20.525 5.1 20.4916 5.18333 20.425 5.25C20.3583 5.31667 20.275 5.35 20.175 5.35H17.525V8C17.525 8.1 17.4916 8.18333 17.425 8.25C17.3583 8.31667 17.275 8.35 17.175 8.35ZM7.17498 6.2C6.42498 6.2 5.78764 5.93733 5.26298 5.412C4.73764 4.88733 4.47498 4.25 4.47498 3.5C4.47498 2.75 4.73764 2.11267 5.26298 1.588C5.78764 1.06267 6.42498 0.799999 7.17498 0.799999C7.92498 0.799999 8.56264 1.06267 9.08798 1.588C9.61264 2.11267 9.87498 2.75 9.87498 3.5C9.87498 4.25 9.61264 4.88733 9.08798 5.412C8.56264 5.93733 7.92498 6.2 7.17498 6.2ZM1.22498 13.2C1.00831 13.2 0.829309 13.129 0.687976 12.987C0.545976 12.8457 0.474976 12.6667 0.474976 12.45V11.9C0.474976 11.5333 0.587309 11.1877 0.811976 10.863C1.03731 10.5377 1.34164 10.2833 1.72498 10.1C2.64164 9.66667 3.55431 9.34167 4.46298 9.125C5.37098 8.90833 6.27498 8.8 7.17498 8.8C8.07498 8.8 8.97898 8.90833 9.88698 9.125C10.7956 9.34167 11.7083 9.66667 12.625 10.1C13.0083 10.2833 13.3126 10.5377 13.538 10.863C13.7626 11.1877 13.875 11.5333 13.875 11.9V12.45C13.875 12.6667 13.8043 12.8457 13.663 12.987C13.521 13.129 13.3416 13.2 13.125 13.2H1.22498ZM1.17498 12.5H13.175V11.9C13.175 11.6667 13.096 11.446 12.938 11.238C12.7793 11.0293 12.5583 10.85 12.275 10.7C11.475 10.3167 10.646 10.0207 9.78798 9.812C8.92931 9.604 8.05831 9.5 7.17498 9.5C6.29164 9.5 5.42064 9.604 4.56198 9.812C3.70398 10.0207 2.87498 10.3167 2.07498 10.7C1.79164 10.85 1.57098 11.0293 1.41298 11.238C1.25431 11.446 1.17498 11.6667 1.17498 11.9V12.5ZM7.17498 5.5C7.72498 5.5 8.19598 5.304 8.58798 4.912C8.97931 4.52067 9.17498 4.05 9.17498 3.5C9.17498 2.95 8.97931 2.47933 8.58798 2.088C8.19598 1.696 7.72498 1.5 7.17498 1.5C6.62498 1.5 6.15431 1.696 5.76298 2.088C5.37098 2.47933 5.17498 2.95 5.17498 3.5C5.17498 4.05 5.37098 4.52067 5.76298 4.912C6.15431 5.304 6.62498 5.5 7.17498 5.5Z'
									fill='#124FC9'
								/>
							</svg>

							<p>
								Cambiar foto <br />
								de Perfil
							</p>
						</div>

						{option && (
							<div className='dropdown-profile'>
								<div className='inner-dropdown'>
									<svg
										width='16'
										height='16'
										viewBox='0 0 16 16'
										fill='none'
										xmlns='http://www.w3.org/2000/svg'
									>
										<g clipPath='url(#clip0_345_91055)'>
											<mask
												id='mask0_345_91055'
												maskUnits='userSpaceOnUse'
												x='0'
												y='0'
												width='16'
												height='16'
											>
												<rect width='16' height='16' fill='#9AB9F8' />
											</mask>
											<g mask='url(#mask0_345_91055)'>
												<path
													d='M3.36667 12.6667H4.23334L9.95001 6.95L9.08334 6.08333L3.36667 11.8V12.6667ZM12.8833 6L10.0333 3.16667L10.9333 2.25C11.2 1.98333 11.5278 1.85 11.9167 1.85C12.3056 1.85 12.6389 1.98333 12.9167 2.25L13.7833 3.13333C14.0611 3.4 14.2027 3.72222 14.208 4.1C14.2138 4.47778 14.0833 4.8 13.8167 5.06667L12.8833 6ZM2.73334 14.0667C2.52223 14.0667 2.34179 13.9918 2.19201 13.842C2.04179 13.6918 1.96667 13.5111 1.96667 13.3V11.5333C1.96667 11.4333 1.98623 11.336 2.02534 11.2413C2.06401 11.1471 2.12223 11.0611 2.20001 10.9833L9.06667 4.11667L11.9167 6.96667L5.05001 13.8333C4.98334 13.9111 4.9029 13.9696 4.80867 14.0087C4.71401 14.0473 4.61112 14.0667 4.50001 14.0667H2.73334Z'
													fill='#3676F5'
												/>
											</g>
										</g>
										<defs>
											<clipPath id='clip0_345_91055'>
												<rect width='16' height='16' fill='white' />
											</clipPath>
										</defs>
									</svg>

									<p>Cambiar Foto de Perfil</p>
								</div>
								<div
									className='inner-dropdown'
									onClick={(e) => {
										setoption(false)
									}}
								>
									<svg
										width='16'
										height='16'
										viewBox='0 0 16 16'
										fill='none'
										xmlns='http://www.w3.org/2000/svg'
									>
										<g clipPath='url(#clip0_345_61547)'>
											<mask
												id='mask0_345_61547'
												maskUnits='userSpaceOnUse'
												x='0'
												y='0'
												width='16'
												height='16'
											>
												<rect width='16' height='16' fill='#9AB9F8' />
											</mask>
											<g mask='url(#mask0_345_61547)'>
												<path
													d='M4.61676 14.1333C4.20565 14.1333 3.8501 13.9862 3.5501 13.692C3.2501 13.3973 3.1001 13.0389 3.1001 12.6167V4.05C2.88899 4.05 2.71121 3.97488 2.56676 3.82466C2.42232 3.67488 2.3501 3.49444 2.3501 3.28333C2.3501 3.07222 2.42232 2.89444 2.56676 2.75C2.71121 2.60555 2.88899 2.53333 3.1001 2.53333H5.91676C5.91676 2.31111 5.98899 2.12777 6.13343 1.98333C6.27788 1.83888 6.45565 1.76666 6.66676 1.76666H9.33343C9.54454 1.76666 9.72232 1.83888 9.86676 1.98333C10.0112 2.12777 10.0834 2.31111 10.0834 2.53333H12.9001C13.1112 2.53333 13.289 2.60555 13.4334 2.75C13.5779 2.89444 13.6501 3.07222 13.6501 3.28333C13.6501 3.49444 13.5779 3.67488 13.4334 3.82466C13.289 3.97488 13.1112 4.05 12.9001 4.05V12.6167C12.9001 13.0389 12.7501 13.3973 12.4501 13.692C12.1501 13.9862 11.7945 14.1333 11.3834 14.1333H4.61676ZM4.61676 4.05V12.6167H11.3834V4.05H4.61676ZM5.93343 10.6167C5.93343 10.8167 6.0001 10.9862 6.13343 11.1253C6.26676 11.264 6.43343 11.3333 6.63343 11.3333C6.83343 11.3333 7.00299 11.264 7.1421 11.1253C7.28076 10.9862 7.3501 10.8167 7.3501 10.6167V6.05C7.3501 5.85 7.28076 5.68044 7.1421 5.54133C7.00299 5.40266 6.83343 5.33333 6.63343 5.33333C6.43343 5.33333 6.26676 5.40266 6.13343 5.54133C6.0001 5.68044 5.93343 5.85 5.93343 6.05V10.6167ZM8.6501 10.6167C8.6501 10.8167 8.71965 10.9862 8.85876 11.1253C8.99743 11.264 9.16676 11.3333 9.36676 11.3333C9.56676 11.3333 9.73343 11.264 9.86676 11.1253C10.0001 10.9862 10.0668 10.8167 10.0668 10.6167V6.05C10.0668 5.85 10.0001 5.68044 9.86676 5.54133C9.73343 5.40266 9.56676 5.33333 9.36676 5.33333C9.16676 5.33333 8.99743 5.40266 8.85876 5.54133C8.71965 5.68044 8.6501 5.85 8.6501 6.05V10.6167Z'
													fill='#3676F5'
												/>
											</g>
										</g>
										<defs>
											<clipPath id='clip0_345_61547'>
												<rect width='16' height='16' fill='white' />
											</clipPath>
										</defs>
									</svg>

									<p>Eliminar Foto de Perfil</p>
								</div>
							</div>
						)}
					</div>
					<div className='presentation-area'>
						<h1>Pedro Perez</h1>
						<p>Administrador</p>
					</div>
				</div>

				<div className='inputs-area'>
					<div className='input-wrapper'>
						<label htmlFor='#email'>Email</label>
						<div className='flex-area-input'>
							<input
								type='text'
								id='email-settings'
								style={{pointerEvents: 'unset'}}
								value={emailSettings}
								onChange={(e) => {
									setemailSettings(e.target.value)
								}}
							/>
							<label htmlFor='email-settings'>
								<svg
									width='16'
									height='16'
									viewBox='0 0 16 16'
									fill='none'
									xmlns='http://www.w3.org/2000/svg'
								>
									<path
										d='M2.2085 13.8333H3.29183L10.4377 6.68751L9.35433 5.60417L2.2085 12.75V13.8333ZM14.1043 5.50001L10.5418 1.95834L11.6668 0.812508C12.0002 0.479174 12.4099 0.312508 12.896 0.312508C13.3821 0.312508 13.7988 0.479174 14.146 0.812508L15.2293 1.91667C15.5766 2.25001 15.7535 2.65279 15.7602 3.12501C15.7674 3.59723 15.6043 4.00001 15.271 4.33334L14.1043 5.50001ZM1.41683 15.5833C1.15294 15.5833 0.927385 15.4897 0.740163 15.3025C0.552385 15.1147 0.458496 14.8889 0.458496 14.625V12.4167C0.458496 12.2917 0.482941 12.17 0.531829 12.0517C0.580163 11.9339 0.65294 11.8264 0.750163 11.7292L9.3335 3.14584L12.896 6.70834L4.31266 15.2917C4.22933 15.3889 4.12877 15.462 4.011 15.5108C3.89266 15.5592 3.76405 15.5833 3.62516 15.5833H1.41683Z'
										fill='#ADADAD'
									/>
								</svg>
							</label>
						</div>
					</div>

					<div className='input-wrapper'>
						<label htmlFor='#pass'>Contraseña</label>
						<div className='flex-area-input'>
							<p>************</p>
							<svg
								onClick={(e) => {
									setpasswordChangePop(true)
								}}
								width='16'
								height='16'
								viewBox='0 0 16 16'
								fill='none'
								xmlns='http://www.w3.org/2000/svg'
							>
								<path
									d='M2.2085 13.8333H3.29183L10.4377 6.68751L9.35433 5.60417L2.2085 12.75V13.8333ZM14.1043 5.50001L10.5418 1.95834L11.6668 0.812508C12.0002 0.479174 12.4099 0.312508 12.896 0.312508C13.3821 0.312508 13.7988 0.479174 14.146 0.812508L15.2293 1.91667C15.5766 2.25001 15.7535 2.65279 15.7602 3.12501C15.7674 3.59723 15.6043 4.00001 15.271 4.33334L14.1043 5.50001ZM1.41683 15.5833C1.15294 15.5833 0.927385 15.4897 0.740163 15.3025C0.552385 15.1147 0.458496 14.8889 0.458496 14.625V12.4167C0.458496 12.2917 0.482941 12.17 0.531829 12.0517C0.580163 11.9339 0.65294 11.8264 0.750163 11.7292L9.3335 3.14584L12.896 6.70834L4.31266 15.2917C4.22933 15.3889 4.12877 15.462 4.011 15.5108C3.89266 15.5592 3.76405 15.5833 3.62516 15.5833H1.41683Z'
									fill='#ADADAD'
								/>
							</svg>
						</div>
					</div>
				</div>

				<div className='switches-area'>
					<div className='switch'>
						<SwitchCustom id={`first_agree`} defaultChecked />

						<p>Recibir Notificaciones al correo</p>
					</div>
					<div className='switch'>
						<SwitchCustom id={`second_agree`} defaultChecked />
						<p>Recibir tickets de soporte al correo</p>
					</div>
				</div>
			</div>

			<button className='back-top-button'>
				<svg
					width='12'
					height='12'
					viewBox='0 0 12 12'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'
				>
					<g clipPath='url(#clip0_345_45166)'>
						<mask
							id='mask0_345_45166'
							maskUnits='userSpaceOnUse'
							x='0'
							y='0'
							width='12'
							height='12'
						>
							<rect width='12' height='12' fill='#D9D9D9' />
						</mask>
						<g mask='url(#mask0_345_45166)'>
							<path
								d='M4.01321 9.57498C3.85487 9.57498 3.72154 9.51865 3.61321 9.40598C3.50487 9.29365 3.45071 9.15832 3.45071 8.99998C3.45071 8.84165 3.50487 8.70632 3.61321 8.59398C3.72154 8.48132 3.85487 8.42498 4.01321 8.42498H7.06321C7.57154 8.42498 8.01321 8.26665 8.38821 7.94998C8.76321 7.63332 8.95071 7.23331 8.95071 6.74998C8.95071 6.26665 8.76321 5.86665 8.38821 5.54998C8.01321 5.23332 7.57154 5.07498 7.06321 5.07498H4.07571L4.91321 5.89998C5.02154 6.00832 5.07571 6.14165 5.07571 6.29998C5.07571 6.45832 5.02154 6.59165 4.91321 6.69998C4.80487 6.80831 4.67154 6.86248 4.51321 6.86248C4.35487 6.86248 4.22154 6.80831 4.11321 6.69998L2.31321 4.89998C2.26321 4.84165 2.22571 4.77915 2.20071 4.71248C2.17571 4.64582 2.16321 4.57498 2.16321 4.49998C2.16321 4.42498 2.17571 4.35415 2.20071 4.28748C2.22571 4.22081 2.26321 4.15831 2.31321 4.09998L4.11321 2.29998C4.22154 2.19165 4.35487 2.13748 4.51321 2.13748C4.67154 2.13748 4.80487 2.19165 4.91321 2.29998C5.02154 2.40831 5.07571 2.54165 5.07571 2.69998C5.07571 2.85831 5.02154 2.99165 4.91321 3.09998L4.07571 3.92498H7.06321C7.88821 3.92498 8.59871 4.19582 9.19471 4.73748C9.79038 5.27915 10.0882 5.94998 10.0882 6.74998C10.0882 7.54998 9.79038 8.22082 9.19471 8.76248C8.59871 9.30415 7.88821 9.57498 7.06321 9.57498H4.01321Z'
								fill='#3676F5'
							/>
						</g>
					</g>
					<defs>
						<clipPath id='clip0_345_45166'>
							<rect width='12' height='12' fill='white' />
						</clipPath>
					</defs>
				</svg>
				Volver al Inicio
			</button>
		</div>
	)
}
